import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import unsupportedQuerySVG from './assets/unsupported-query.svg'
import messages from './messages'
import { type GlobalSearchStateMessage } from '../../../../data-access/types/GlobalSearchResponse'

interface IGlobalSearchUnsupportedQueryStateProps {
  message?: Nullable<GlobalSearchStateMessage>
}

export const GlobalSearchUnsupportedQueryState = ({
  message,
}: IGlobalSearchUnsupportedQueryStateProps) => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='404'
      imgUrl={unsupportedQuerySVG}
      header={message?.title ?? intl.formatMessage(messages.header)}
      content={
        <Text>
          {message?.description ?? intl.formatMessage(messages.content)}
        </Text>
      }
    />
  )
}
